export enum SummaryLineName {
  pretax = 'Tax Deferred',
  taxFree = 'Tax Free',
  taxable = 'Taxable',
  totalAssets = 'Total Assets',
  totalRMDs = 'Total RMDs',
  totalTaxesPaid = 'Total Taxes Paid',
}
